import { useNotify } from '@hotjar/hotsauce';
import { useSubscription } from '@hotjar/webapp/hooks/useSubscription';

import { useCurrentSite } from '@hotjar/site';
import type { ForwardToSlackProps } from './ForwardToSlack';
import { ForwardToSlack } from './ForwardToSlack';

type ForwardToSlackConnectedProps = Omit<
  ForwardToSlackProps,
  'currentSite' | 'upsell' | 'onEnableSuccess' | 'onEnableError'
>;

export const ForwardToSlackConnected = ({
  settings,
  onChange,
  header,
  subtext,
  trackingState,
  contextOfUse,
}: ForwardToSlackConnectedProps): JSX.Element => {
  const { showToast } = useNotify();
  const { data: currentSite } = useCurrentSite();
  const { upsell } = useSubscription();

  return (
    <ForwardToSlack
      trackingState={trackingState}
      onChange={onChange}
      settings={settings}
      header={header}
      subtext={subtext}
      currentSite={currentSite}
      upsell={upsell}
      onEnableSuccess={(text: string) => showToast({ text, kind: 'success' })}
      onEnableError={(text: string) => showToast({ text, kind: 'danger' })}
      contextOfUse={contextOfUse}
    />
  );
};
